var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSadface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.5 90C178.5 138.877 138.877 178.5 90 178.5C41.1228 178.5 1.5 138.877 1.5 90C1.5 41.1228 41.1228 1.5 90 1.5C138.877 1.5 178.5 41.1228 178.5 90Z",
    stroke: "#6A6A63",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.515 125.758C118.67 116.326 105.067 110.492 90.0404 110.492C74.8526 110.492 61.1186 116.452 51.25 126.063C59.8517 113.943 73.998 106.034 89.9916 106.034C105.85 106.034 119.893 113.81 128.515 125.758Z",
    fill: "#6A6A63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.125 72.9701C48.125 81.1689 52.6566 87.8153 58.2467 87.8153C63.8367 87.8153 68.3684 81.1689 68.3684 72.9701C68.3684 64.7714 63.8367 58.125 58.2467 58.125C52.6566 58.125 48.125 64.7714 48.125 72.9701Z",
    fill: "#6A6A63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.879 72.9701C110.879 81.1689 115.411 87.8153 121.001 87.8153C126.591 87.8153 131.123 81.1689 131.123 72.9701C131.123 64.7714 126.591 58.125 121.001 58.125C115.411 58.125 110.879 64.7714 110.879 72.9701Z",
    fill: "#6A6A63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadface);
export default __webpack_public_path__ + "static/media/sadface.fd751a42716a0182b7617a6bfc2817ad.svg";
export { ForwardRef as ReactComponent };